module.exports = __webpack_public_path__ + "contacts-cbf4f629/503-4047d3143a02e6fe213c64b20551cbdf.svg";